import { useViewerCapabilities } from "./use-viewer-capabilities";

/**
 * Whether the signed-in user may create, upload, edit, or process project work. Reactive to role
 * changes, so a demoted member loses write controls without a reload. False until the profile loads.
 */
export function useCanEdit() {
  return useViewerCapabilities()?.canEditWork ?? false;
}
